// Applique un dictionnaire de langue à tous les éléments marqués data-i18n-* du DOM.
// index.html porte les clés ; ce module ne connaît que la mécanique d'application.
import { translate } from '../core/i18n.js';
import { legalParams } from './legalText.js';
import { setTextWithEmoji } from './dom.js';
import { markSecret } from './settingsSecret.js';

const ATTR_TARGETS = [
  ['data-i18n', (el, text) => { setTextWithEmoji(el, text); }], // emoji agrandis (« ⚠️ Dès qu'un réglage… »)
  ['data-i18n-placeholder', (el, text) => { el.placeholder = text; }],
  ['data-i18n-title', (el, text) => { el.title = text; }],
  ['data-i18n-aria-label', (el, text) => { el.setAttribute('aria-label', text); }],
  ['data-i18n-alt', (el, text) => { el.alt = text; }],
];

/**
 * @param {object} dict un dictionnaire complet (ex. translations.fr)
 * @param {object} [params] valeurs des {paramètres} des textes (version du pied de page par défaut)
 */
export function applyTranslations(dict, params = legalParams()) {
  for (const [attr, apply] of ATTR_TARGETS) {
    document.querySelectorAll(`[${attr}]`).forEach((el) => {
      const key = el.getAttribute(attr);
      apply(el, translate(dict, key, params));
      if (attr === 'data-i18n' && el.hasAttribute('data-secret-mark')) markSecret(el); // zone secrète sur « 0cog™ » (réglages)
    });
  }

  if (dict.meta?.lang) document.documentElement.lang = dict.meta.lang;
  const description = document.querySelector('meta[name="description"]');
  if (description) description.content = translate(dict, 'meta.description');
}
